import m2Sidebar from "@components/sidebar/m2_sidebar";
import cropper from "@components/cropper/cropper.vue";
import m2_examRegMenu from '@components/examRegMenu/m2_examRegMenu.vue'
import m1_examRegMenu from '@components/examRegMenu/m1_examRegMenu.vue'
import m1_subExamRegMenu from '@components/subExamRegMenu/m1_subExamRegMenu.vue'
import m2_subExamRegMenu from '@components/subExamRegMenu/m2_subExamRegMenu.vue'
export default {
  components: {
    'm2ExamRegMenu':m2_examRegMenu,
    "m2Sidebar":m2Sidebar,
    "m2SubExamRegMenu":m2_subExamRegMenu,
    "examRegMenu":m1_examRegMenu,
    "subExamRegMenu":m1_subExamRegMenu,
    cropper,
  },
  data() {
    return {
      field: [],
      validResult: true,
      cert_pic: {},
      cert_pic_have: false,
      example_pic: [],
      upload_img: [],
      btnDisable: false,
      face_identification_data: "",
      proc_id: "",
      dialogVisible: false,
      dialogImageUrl: "",
      cropperDialog: false
    };
  },
  methods: {
    //   关闭dialog
    handleClose() {
      this.cropperDialog = false;
    },
    getData: function() {
      let examRegInfo = this.$store.state.examRegInfo.examRegInfo;
      if (examRegInfo === null) {
        this.$router.push({ name: "default.examReg.chooseBatch" });
      }
      if (examRegInfo.pic_info_confs === null) {
        this.$router.push({ name: "default.examReg.chooseBatch" });
      }
      this.field = examRegInfo.pic_info_confs;
      let passLength = 0;
      for (let item of this.field) {
        this.displayRule(item);
        if (item.is_pass) {
          passLength++;
        }
        this.example_pic.push({ url: "" });
        this.upload_img.push({ url: "" });
        if (item.sub_confs[0].sample_links[0]) {
          this.getImgUrl(
            item.sub_confs[0].sample_links[0],
            this.field.indexOf(item),
            1
          );
        }
        if (item.value) {
          this.getImgUrl(item.value, this.field.indexOf(item), 2);
        }
        if (item._item_type === "cert_pic") {
          this.cert_pic = item;
          this.cert_pic_have = true;
        }
      }
      if (passLength == 0) {
        if (this.$store.state.examRegInfo.backOrNextStep == "next") {
          this.nextStep();
            // this.delayNextStep();
        } else {
          this.preStep();
        }
      }
    },
    dialogDisplay(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    displayRule(item) {
      let text_info_confs = this.$store.state.examRegInfo.examRegInfo
        .text_info_confs;
      if (item.rules.length > 0) {
        for (let i of item.rules) {
          for (let j of text_info_confs) {
            if (j.tag == i.tag) {
              if (displayRuleType[i.condition]) {
                if (j.type == 3) {
                  let states = true;
                  for (let option of i.value) {
                    if (j.value.indexOf(option) == -1) {
                      states = false;
                    }
                  }
                  if (!states) {
                    item.value = "";
                    item.is_pass = false;
                    return false;
                  }
                } else {
                  if (i.value.indexOf(j.value) == -1) {
                    item.value = "";
                    item.is_pass = false;
                    return false;
                  }
                }
              } else {
                if (!j.value) {
                  item.value = "";
                  item.is_pass = false;
                  return false;
                }
              }
            }
          }
        }
        item.is_pass = true;
        return true;
      } else {
        item.is_pass = true;
        return true;
      }
    },
    setTip(tip) {
      if (tip) {
        return tip.replace("\n", "<br>");
      } else {
        return "";
      }
    },
    computerNumber(num, type) {
      let Node = {
        No_Restrict: "1",
        PDF: "2",
        Word: "4",
        PPT: "8",
        "JPG,JPEG": "16",
        PNG: "32"
      };
      let format = [];
      for (let item in Node) {
        if ((num & Node[item]) == parseInt(Node[item])) {
          format.push(...item.split(','));
        }
      }
      if (type === 1) {
        let string = "";
        for (let i in format) {
          if (i == format.length - 1) {
            string = string + format[i];
          } else {
            string = string + format[i] + ",";
          }
        }
        return string;
      } else {
        let string = "";
        for (let i in format) {
          if (i == format.length - 1) {
            if (format[i] === "JPG") string = string + "image/jpeg";
            if (format[i] === "PNG") string = string + "image/png";
          } else {
            string = string + "image/jpeg" + ", ";
          }
        }
        return string;
      }
    },
    beforeAvatarUpload(file) {
      const isLt1M = file.size / 1024 / 1024 <= 1;
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      if (!isJPG) {
        console.log(1,_upload.file.type,type)

        this.$alert("请上传正确格式的图片", { confirmButtonText: "确定" });
        return false;
      }
      if (!isLt1M) {
        this.$alert("图片过大，请上传1M以内的图片", {
          confirmButtonText: "确定"
        });
        return false;
      }
      return true;
    },
    upload: function(_upload) {
      let vm = this;
      var _URL = window.URL || window.webkitURL;
      let img = new Image();
      let type = this.computerNumber(
        _upload.data.item.sub_confs[0].support_types,
        2
      );
      if (type.indexOf(_upload.file.type) != -1) {
        img.onload = function() {
          let limit_size = _upload.data.item.sub_confs[0].pic_size;
          if (limit_size) {
            if (
              limit_size.split("*")[0] == this.width &&
              limit_size.split("*")[1] == this.height
            ) {
              _upload.data.callback(_upload);
            } else {
              vm.$alert("图片尺寸错误，请上传" + limit_size + "大小的图片", {
                confirmButtonText: "确定"
              });
            }
          } else {
            _upload.data.callback(_upload);
          }
        };
        img.src = _URL.createObjectURL(_upload.file);
      } else {
        this.$alert("请上传正确格式的图片", { confirmButtonText: "确定" });
      }
    },
    uploadCallback: function(_upload, ifLimitSize = 0) {
      let index;
      let fileData;
      //判断是否为限制了宽高，设置传输数据
      if (ifLimitSize == 1) {
        index = 0;
        fileData = _upload.file.data;
      } else {
        index = this.field.indexOf(_upload.data.item);
        fileData = _upload.file;
      }
      this.$http
        .post(globalProvider.serviceUrl("oss/_f/g/lk/up/pc"), {
          proc_id: _upload.data.item.value,
          file_guid: this.upload_img[index].file_guid,
          file_name: _upload.file.name,
          type: _upload.file.type
        })
        .then(data => {
          if (data.body.code == resultCode.Success) {
            this.btnDisable = false;
            this.proc_id = data.body.data.proc_id;
            let uploadUrl = data.body.data.link;
            this.field[index].value = data.body.data.proc_id;
            this.$http
              .put(uploadUrl, fileData, {
                headers: {
                  "Content-Type": _upload.file.type,
                  "Content-Disposition":
                    "attachment;filename=" + encodeURI(_upload.file.name)
                }
              })
              .then(response => {
                if (response.status == 200) {
                  this.getImgUrl(this.field[index].value, index, 2);
                  this.cropperDialog = false;
                } else if (data.body.code == resultCode.NotSuccess) {
                  this.upload_img[index].file_guid = "";
                  this.$alert(getErrorMessage(data.body.message));
                }
              });
          }
        });
    },
    getImgUrl: function(proc_id, id, place) {
      if (proc_id != null||!proc_id||(proc_id instanceof Array && proc_id.length == 0)) {
        this.$http
          .get(globalProvider.serviceUrl("oss/_f/g/lk/dl/{proc_id}"), {
            params: {
              proc_id: proc_id,
              loading: true
            }
          })
          .then(data => {
            if (data.body.code == resultCode.Success) {
              if (place == 1) {
                this.example_pic[id].url = data.body.data[0].link;
              }
              if (place == 2) {
                this.upload_img[id].url = data.body.data[0].link;
                this.upload_img[id].file_guid = data.body.data[0].file_guid;
              }
            } else if (data.body.code == resultCode.NotSuccess) {
              this.$alert(getErrorMessage(data.body.message));
            }
          });
      }
    },
    checkData: function(callback) {
      this.validResult = true;
      this.field.forEach(item => {
        if (item.is_pass) {
          if (item.is_required) {
            if (
              (item.value instanceof Array && item.value.length == 0) ||
              !item.value
            ) {
              this.validResult = false;
              return;
            }
          }
        }
      });
      callback && callback();
    },
    preStep: function() {
      let RegInfoModel = this.$store.state.examRegInfo.examRegInfo;
      if (RegInfoModel.text_info_confs.length > 0) {
        this.$router.push({ name: "default.examReg.baseCollection" });
      } else {
        this.$router.push({ name: "default.examReg.examNotes" });
      }
    },
    // delayNextStep:function(){
    //   const delayTime=Math.random()*5000;
    //   setTimeout(this.nextStep, 2000);
    // },
    nextStep: function() {
      this.$store.commit("setBackOrNextStep", "next");
      this.btnDisable = true;
      this.checkData(() => {
        if (this.validResult) {
          this.$store.commit("setExamRegInfoItem", {
            pic_info_confs: this.field
          });
          let st = [],
            num = 0;
          for (let item of this.field) {
            if (item.is_pass) {
              st.push(item);
            }
          }
          for (let item of this.field) {
            if (item._item_type == "cert_pic") {
              //获取人脸识别状态开关
              this.$http
                .get(globalProvider.serviceUrl("e_reg/g/efr/s"))
                .then(res => {
                  if (res.body.code == 10) {
                    this.face_identification_data = res.body.data;
                    if (this.face_identification_data == 1) {
                      this.btnDisable = true;
                      //人脸识别图片检测
                      this.$http
                        .get(
                          globalProvider.serviceUrl("e_reg/c/fr/pi/{proc_id}"),
                          {
                            params: { proc_id: item.value }
                          }
                        )
                        .then(res => {
                          if (res.body.data) {
                            this.btnDisable = false;
                            this.postData(st);
                          } else {
                            this.$alert(getErrorMessage(res.body.message));
                            this.btnDisable = true;
                          }
                        });
                    } else {
                      this.postData(st);
                    }
                  }
                });
            } else {
              num++;
            }
          }
          if (num == this.field.length) {
            this.postData(st);
          }
        } else {
          this.btnDisable = false;
          this.$alert("请上传所有图片", { confirmButtonText: "确定" });
        }
      });
    },
    postData(st) {
      let examRegInfo = this.$store.state.examRegInfo.examRegInfo;
      this.$http
        .post(globalProvider.serviceUrl("e_reg/us/rgsi/p"), {
          eri: examRegInfo.exam_registration_id,
          i: st
        })
        .then(data => {
          if (data.body.code === resultCode.Success) {
            if (examRegInfo.file_info_confs.length > 0) {
              this.$router.push({ name: "default.examReg.fileCollection" });
            } else {
              if (examRegInfo.reg_mode == reg_mode.region_subject) {
                this.$router.push({ name: "default.examReg.chooseExamRegion" });
              } else {
                this.$router.push({ name: "default.examReg.chooseSubject2" });
              }
            }
          } else if (data.body.code == resultCode.NotSuccess) {
            this.$alert(getErrorMessage(data.body.message));
            this.Other_document_types = true;
          }
        });
    }
  },
  created: function() {
    this.$store.commit("setHeaderState", "3");
    this.getData();
  }
};
// </script>